import { render, staticRenderFns } from "./inquiry.vue?vue&type=template&id=4ca094ec&scoped=true&"
import script from "./inquiry.vue?vue&type=script&lang=js&"
export * from "./inquiry.vue?vue&type=script&lang=js&"
import style0 from "./inquiry.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./inquiry.vue?vue&type=style&index=1&id=4ca094ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca094ec",
  null
  
)

export default component.exports